<template lang="pug">
form(autocomplete="off")
  input#stake-input.form-control.rounded-0.form-control-sm.text-center.border-0(
    type="text"
    :value="checkLoading"
    @input="handleInput"
    @keypress="validateStake($event)"
    @blur="handleStake"
    ref="stake"
    autocomplete="nope"
    readonly
    )
</template>

<script>
import StakeCheck from "@/library/_stakeinput.js";
export default {
  props: {
    value: {
      type: [Number, String]
    },
    loadbet: {
      type: Boolean
    }
  },
  data() {
		return {
      autoSelect: true,
    }
  },
  computed: {
    checkLoading() {
      if(!this.loadbet){
        if(this.autoSelect){
          this.setSelect();
        }
        return this.value;
      }
    }
  },
  mounted() {
    this.setSelect();
  },
  methods: {
    // getCaret(element) {
    //   if (element.selectionStart) return element.selectionStart;
    //   else if (document.selection) {
    //     //IE specific
    //     element.focus();
    //     element.select();

    //     var r = document.selection.createRange();
    //     if (r == null) return 0;

    //     var re = element.createTextRange(),
    //       rc = re.duplicate();
    //     re.moveToBookmark(r.getBookmark());
    //     rc.setEndPoint("EndToStart", re);
    //     return rc.text.length;
    //   }

    //   return 0;
    // },
    validateStake(evt) {
      StakeCheck.validate(evt);
    },
    handleInput(e) {
      var chk = StakeCheck.validateWord(e);
      if(!chk){
        this.$refs.stake.value = this.value;
      }
      this.autoSelect = false;
      this.$emit("input", e.target.value);
    },
    handleStake() {
      this.autoSelect = true;
      this.$emit("handleStake");
    },
    focus() {
      // Skip when embedded cross-origin: programmatic focus is blocked ("Blocked autofocusing…").
      if (typeof window !== "undefined" && window.self !== window.top) {
        try {
          void window.parent.location.href;
        } catch (_) {
          return;
        }
      }
      this.$refs.stake.focus();
    },
    setSelect() {
      // setTimeout(() => {
      //   if ($("#stake-input") != undefined) {
      //     $("#stake-input").select();
      //   }
      // }, 100);
    }
  }
};
</script>